import './Spinner.css';

export default function Spinner({ size = 40, color = 'var(--pink)' }) {
  const basePx = size / 40;
  return (
    <span
      className="customer-portal-loader"
      style={{ '--loader-color': color, '--loader-size': `${basePx}px` }}
      role="status"
      aria-label="Loading"
    />
  );
}
